import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';
@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {


  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl + '/reference';
  }



  //dev approve


  async createmasterDeduction(obj:any){

    const resp = await this.http.post<any>(this.main.httpUrl + '/info/masterdeduction/createmasterded', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }

   async getmasterdeduction(acct_id:any){
    const resp= this.http.get<any>(this.main.httpUrl + '/info/masterdeduction/getmasterdeduction'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }


  async deletemasterded(acct_id:any){
    const resp= this.http.delete<any>(this.main.httpUrl + '/info/masterdeduction/deletemasterded'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }


  async updatemasterded(obj:any){

    const resp = await this.http.put<any>(this.main.httpUrl + '/info/masterdeduction/updatemasterded', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
  async inserforappr(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/administration/LevelOfAppr/inserforappr', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async getApprovalLevels(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/administration/LevelOfAppr/getApprovalLevels'+ obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async zoneheadforza(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/head/zoneheadforza'+ obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async updateApprovalLevel(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/administration/LevelOfAppr/updateApprovalLevel', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }


  async getHeadRecord(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/head/getheadDetails'+ obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  // async getZoneHead(obj){
  //   const resp= this.http.get<any>(this.main.httpUrl+'/info/head/getZoneHead'+ obj ).toPromise().then(res =>{
  //     return res
  //   });
  //   return resp
  // }

  //budget

  async getlogOfbud(obj:any){
    const resp= this.http.post<any>(this.main.httpUrl+'/info/bud/getlogOfbud',JSON.parse(obj) ).toPromise().then(res =>{
      return res
    });
    return resp
  }


  async getBudget(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/bud/getbud'+ obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async createBudget(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/info/bud/createbud', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async updateBudget(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/bud/updatebud', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async deleteBudget(obj:any){
    const resp = await this.http.delete<any>(this.main.httpUrl + '/info/bud/deletebud'+ obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }

   async getAllExpenseOnBud(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/info/bud/getAllExpenseOnBud',JSON.parse(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
  //budget
  async getdataforprint(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/emb/getdataforprint'+ obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async createDeduction(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/info/deduction/createded', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async addevent(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl2 + '/account/event/addevent', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async getDeductionList(acct_id:any){
    const resp= this.http.get<any>(this.main.httpUrl + '/info/deduction/getded'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async deleteDeduction(obj:any){
    const resp = await this.http.delete<any>(this.main.httpUrl + '/info/deduction/deleteded'+ obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async updateDeduction(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/deduction/updateded', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async updatededeventcode(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/deduction/updatededeventcode', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
  async createField(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/md/fields/createField', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }

   async getAllFields(acct_id:any){
    const resp= this.http.get<any>(this.main.httpUrl + '/md/fields/getFields'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async getDataType(acct_id:any){
    const resp= this.http.get<any>(this.main.httpUrl + '/md/fields/'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async updateFields(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/md/fields/updateField', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async deleteFields(obj:any){
    const resp = await this.http.delete<any>(this.main.httpUrl + '/md/fields/deleteField'+ JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async createCodeValue(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/md/codeValue/createcodevalue', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async getAllCodeValue(b_acct_id:any){
    const resp= this.http.get<any>(this.main.httpUrl + '/md/codeValue/getCodeValues'+b_acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async updateCodeValue(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/md/codeValue/updatecodevalue', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
   async deleteCodeValue(obj:any){
    const resp = await this.http.delete<any>(this.main.httpUrl + '/md/codeValue/deletecodevalue'+ obj ).toPromise().then(res => {
      return res;
    });
    return resp;
   }
  async addHierarchy(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/dataDictionary/hierarchy/addHierarchy', obj ).toPromise().then(res => {

    return res;
    });
    return resp;
    }
    async getDataFromHierarchy(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/dataDictionary/hierarchy/getDataFromHierarchy'+ obj ).toPromise().then(res => {

    return res;
    });
    return resp;
    }
    async updateDatafromHierarchy(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/dataDictionary/hierarchy/updateDatafromHierarchy', obj ).toPromise().then(res => {

    return res;
    });
    return resp;
    }
    async deleteDatafromHierarchy(obj:any) {
    const resp = await this.http.delete<any>(this.main.httpUrl + '/dataDictionary/hierarchy/deleteDatafromHierarchy'+ obj ).toPromise().then(res => {

    return res;
    });
    return resp;
    }
  async deleteUploadedFile(id: any) {
    const resp = await this.http.delete<any>(this.main.httpUrl + '/upload/deleteUploadedFile' +id ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async referenceFileProcess(obj: Object) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/upload/processUploadedFile', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async validateFile(obj: Object) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/upload/validateUploadedFile', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getUploadedReferenceFiles(acct_id:any){
    const res = await this.http.get<any>(this.main.httpUrl + '/upload/getUploadedReferenceFiles' + acct_id ).toPromise().then(res => {

      return res;
    });
    return res;
  }
  async getAccountStore(acct_id:any){
    const res = await this.http.get<any>(this.main.httpUrl + '/platformdata/getdatastore' + acct_id ).toPromise().then(res => {

      return res;
    });
    return res;
  }
  async getAllReferenceFiles(acct_id:any) {

    const res = await this.http.get<any>(this.httpUrl + '/getAllReferenceFiles' + acct_id ).toPromise().then(res => {

      return res;
    });
    return res;
  }
  async getconfiguredFields(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/datadictionary/getconfiguredFields' + obj ).toPromise().then(res => {

      return res;
    });
    return resp;
  }
  async createNewRefFile(obj:any) {
    const resp = await this.http.post<any>(this.httpUrl + '/createreferencefile', obj ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async updateReferenceFile(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl + '/updateReferenceFile', obj ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async deleteRefFile(obj:any) {
    const resp = await this.http.delete<any>(this.httpUrl + '/deleteReferenceFile' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getReferenceData(obj:any){
    const resp = await this.http.get<any>(this.httpUrl + '/getreferencedata' + JSON.stringify(obj) ).toPromise().then(res => {

      return res;
    });
    return resp;
  }
  async insertRow(obj:any){
    const resp = await this.http.post<any>(this.httpUrl + '/addRow', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteRow(obj:any){
    const resp = await this.http.delete<any>(this.httpUrl + '/deleteRow' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteAllRows(obj:any){
    const resp = await this.http.delete<any>(this.httpUrl + '/deleteAllRows' + JSON.stringify(obj) ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async changeStateOfAllRows(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl + '/changeStateOfAllRows', obj ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async updateRow(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl + '/updateRow', obj ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getRefAccountDetail(acct_id:any){
    const resp= this.http.get<any>(this.httpUrl+'/accountdetails'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async getExchangeRate(acct_id:any){
    const resp= this.http.get<any>(this.httpUrl+'/getexchangerate'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async getOrganisation(acct_id:any){
    const resp= this.http.get<any>(this.httpUrl+'/getOrganisation'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async getPresentationCurrency(acct_id:any){
    const resp= this.http.get<any>(this.httpUrl+'/getPresentationCurrency'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async deleteAccount(params:any){
    const resp = await this.http.delete<any>(this.httpUrl + '/deleteaccountinfo' + params ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
 async Account_Setup_insert(obj:any){
  const resp = await this.http.post<any>(this.httpUrl + '/insertaccountdetails', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async Account_Setup_update(obj:any){
  const resp = await this.http.put<any>(this.httpUrl + '/updateaccountinfo', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async updateExchnageRate(obj:any){
  const resp = await this.http.put<any>(this.httpUrl + '/updateExchangeRate', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async updateOrg(obj:any){
  const resp = await this.http.put<any>(this.httpUrl + '/updateOrganisation', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async addExchnageRate(obj:any){
  const resp = await this.http.post<any>(this.httpUrl + '/insertExchangeRate', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async deleteExchangeRate(obj:any){
  const resp = await this.http.post<any>(this.httpUrl + '/deleteExchangeRate', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async addOrganisation(obj:any){
  const resp = await this.http.post<any>(this.httpUrl + '/insertOrganisation', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async deleteOrganisation(obj:any){
  const resp = await this.http.delete<any>(this.httpUrl + '/deleteOrganisation'+ JSON.stringify(obj)).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async createGeometry(obj:any){
  const resp = await this.http.post<any>(this.main.httpUrl + '/info/geometry/creategeometry', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async upddateGeometry(obj:any){
  const resp = await this.http.put<any>(this.main.httpUrl + '/info/geometry/updategeometry', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async getGeometry(acct_id:any){
  const resp= this.http.get<any>(this.main.httpUrl+'/info/geometry/getgeometry'+acct_id).toPromise().then(res =>{
    return res
  });
  return resp
}
async deleteGeometry(obj:any){
  const resp = await this.http.delete<any>(this.main.httpUrl+'/info/geometry/deletegeometry'+ obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async createEMB(obj:any){
  const resp = await this.http.post<any>(this.main.httpUrl + '/info/emb/createEMB', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }
 async getLastEMB(acct_id:any){
  const resp= this.http.get<any>(this.main.httpUrl+'/info/emb/getLastEmb'+acct_id ).toPromise().then(res =>{
    return res
  });
  return resp
}
async getEmbforupdate(obj:any){
  const resp= this.http.get<any>(this.main.httpUrl+'/info/emb/getEmbforupdate'+ obj ).toPromise().then(res =>{
    return res
  });
  return resp
}
async getembforprint(obj:any){
  const resp= this.http.get<any>(this.main.httpUrl+'/info/emb/getembforprint'+ obj ).toPromise().then(res =>{
    return res
  });
  return resp
}
async getEmbforbill(obj:any){
  const resp= this.http.get<any>(this.main.httpUrl+'/info/emb/getEmbforbill'+ obj ).toPromise().then(res =>{
    return res
  });
  return resp
}
async getEmbList(acct_id:any){
  const resp= this.http.get<any>(this.main.httpUrl+'/info/emb/getEmb'+acct_id).toPromise().then(res =>{
    return res
  });
  return resp
}
async deleteEMB(obj:any){
  const resp = await this.http.delete<any>(this.main.httpUrl+'/info/emb/deleteEMB'+ obj ).toPromise().then(res => {
    return res;
  });
  return resp;

}
async updateEMB(obj:any){
  const resp = await this.http.put<any>(this.main.httpUrl + '/info/emb/updateEMB', obj ).toPromise().then(res => {
    return res;
  });
  return resp;
 }

 //Work Zone Project
 async getWorkHead(obj:any){
  const resp= this.http.get<any>(this.main.httpUrl+'/info/head/getWorkHead'+ obj ).toPromise().then(res =>{
    return res
  });
  return resp
}

async createWorkHead(obj:any){
  const resp= this.http.post<any>(this.main.httpUrl+'/info/head/createWorkHead', obj ).toPromise().then(res =>{
    return res
  });
  return resp
}

async updateWorkHead(obj:any){
  const resp= this.http.post<any>(this.main.httpUrl+'/info/head/updateWorkHead', obj ).toPromise().then(res =>{
    return res
  });
  return resp
}

async deleteWorkHead(obj:any){
  const resp= this.http.delete<any>(this.main.httpUrl+'/info/head/deleteWorkHead'+ obj ).toPromise().then(res =>{
    return res
  });
  return resp
}


//work head


  //Project head

  async getProjectHead(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/head/getProjectHead'+ obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async createProjectHead(obj:any){
    const resp= this.http.post<any>(this.main.httpUrl+'/info/head/createProjectHead', obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async updateProjectHead(obj:any){
    const resp= this.http.post<any>(this.main.httpUrl+'/info/head/updateProjectHead', obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }

  async deleteProjectHead(obj:any){
    const resp= this.http.delete<any>(this.main.httpUrl+'/info/head/deleteProjectHead'+ obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }


  //Project head

    //Zone head

    async getZoneHead(obj:any){
      const resp= this.http.get<any>(this.main.httpUrl+'/info/head/getZoneHead'+ obj ).toPromise().then(res =>{
        return res
      });
      return resp
    }

    async workheadFromProj(obj:any){
      const resp= this.http.get<any>(this.main.httpUrl+'/info/head/workheadFromProj'+ obj ).toPromise().then(res =>{
        return res
      });
      return resp
    }
    async Projectheadfromzone(obj:any){
      const resp= this.http.get<any>(this.main.httpUrl+'/info/head/Projectheadfromzone'+ obj ).toPromise().then(res =>{
        return res
      });
      return resp
    }

    async createZoneHead(obj:any){
      const resp= this.http.post<any>(this.main.httpUrl+'/info/head/createZoneHead', obj ).toPromise().then(res =>{
        return res
      });
      return resp
    }

    async updateZoneHead(obj:any){
      const resp= this.http.post<any>(this.main.httpUrl+'/info/head/updateZoneHead', obj ).toPromise().then(res =>{
        return res
      });
      return resp
    }

    async deleteZoneHead(obj:any){
      const resp= this.http.delete<any>(this.main.httpUrl+'/info/head/deleteZoneHead'+ obj ).toPromise().then(res =>{
        return res
      });
      return resp
    }


}
